<div class="user-title">
    <!-- <div class="form-separator"></div> -->
    <h2>{{ titleTranslateKey | translate }}</h2>

    <!-- Add user buttons slot -->
    <div class="buttons-container">
        <ng-content></ng-content>
    </div>
</div>